import {
  Component, ElementRef, ViewChild, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, Renderer2
} from '@angular/core'; import { Capacitor } from '@capacitor/core';
import { map, catchError } from 'rxjs/operators'; import type Swiper from 'swiper';
import { of } from 'rxjs'; import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { MessageService, ConfirmationService, MenuItem } from 'primeng/api';
import { DomSanitizer } from '@angular/platform-browser';
import {
  InstagramGalleryService,
  FacebookPage,
  InstagramBusinessAccount
} from 'src/app/services/instagram-gallery.service';
import {
  InstagramGalleryItem,
  matchesMediaType,
  mergeUniqueItems
} from './instagram-gallery-shared';


@Component({
  selector: 'app-instagram-gallery',
  templateUrl: './instagram-gallery.component.html',
  styleUrls: ['./instagram-gallery.component.scss']
})
export class InstagramGalleryComponent implements OnChanges, OnInit {

  @Input() showContent = true;
  @Input() showAutoPublish = true;
  @Output() hashtagResults = new EventEmitter<InstagramGalleryItem[]>();
  @Output() tagsResults = new EventEmitter<InstagramGalleryItem[]>();
  @Output() mediaResults = new EventEmitter<InstagramGalleryItem[]>();
  @Output() storiesResults = new EventEmitter<InstagramGalleryItem[]>();
  @Input() isFeed = true;
  IsFeedTemp = true;

  @Output() selectedFacebookAccountIdChange = new EventEmitter<string>();
  @Output() selectedInstagramAccountIdChange = new EventEmitter<string>();
  @Output() hashtagChange = new EventEmitter<string>();
  @Output() activeTabChange = new EventEmitter<MenuItem>();

  @Input() enablePanelAdjustment = false;
  @ViewChild('dialogGaleriaRef', { static: false }) dialogGaleriaRef!: ElementRef;
  @ViewChild('dialogGaleriaRef2', { static: false }) dialogGaleriaRef2!: ElementRef;
  @ViewChild('dialogGaleriaRef3', { static: false }) dialogGaleriaRef3!: ElementRef;
  @ViewChild('dialogGaleriaRef4', { static: false }) dialogGaleriaRef4!: ElementRef;

  facebookAccounts: any[] = [];
  selectedAccountId?: string;
  pages: FacebookPage[] = [];
  selectedPage?: FacebookPage;
  instagramAccount?: InstagramBusinessAccount | null;

  tabs: MenuItem[] = [];
  activeTab!: MenuItem;

  hashtag = '';
  media: InstagramGalleryItem[] = [];
  private _mediaMode: 'recent' | 'top_media' = 'recent';
  taggedMedia: InstagramGalleryItem[] = [];
  displayAguarde = false;

  get mediaMode(): 'recent' | 'top_media' {
    return this._mediaMode;
  }

  set mediaMode(value: 'recent' | 'top_media') {
    if (value === this._mediaMode) return;
    this._mediaMode = value;
    // Um cursor emitido pelo modo anterior (recent/top_media) não é válido no
    // outro modo — invalida o estado acumulado da aba HashTag pra evitar
    // reaproveitar hashtagAfter/rawMedia da busca anterior.
    this.rawMedia = [];
    this.media = [];
    this.hashtagAfter = undefined;
    this.hasMoreHashTag = false;
    this.hasSearched = false;
  }

  @Input() autoPublish = false; // recebe valor inicial (se o pai quiser controlar)
  @Output() autoPublishChange = new EventEmitter<boolean>(); // notifica mudanças para o pai

  // Sempre que mudar o valor do switch:
  onToggleAutoPublish(newValue: boolean) {
    this.autoPublish = newValue;
    this.autoPublishChange.emit(newValue); // notifica o pai
  }

  mediaModeOptions = [
    { label: 'Recentes', value: 'recent' },
    { label: 'em destaque', value: 'top_media' }
  ];

  selectedHashtagMediaTypes: string[] = [];
  hashtagAfter?: string;
  pageSize = 10;
  rawMedia: InstagramGalleryItem[] = [];
  hasMoreHashTag = false;
  pageSizeHashTag = 10;

  selectedTagsMediaTypes: string[] = [];
  allTaggedMediaCache: InstagramGalleryItem[] = [];
  pageSizeTags = 10;
  taggedOffset = 0;
  hasMoreTags = false;

  selectedFacebookAccountId?: string;
  lastHashtagId?: string;
  showHashtagLimitDialog: boolean = false;
  hashtagLimitMessage: string = '';

  hasSearched = false;
  hasSearched1 = false;
  hasSearched2 = false;
  hasSearched3 = false;

  // Tamanho de página usado nos dois dialogs de posts (Facebook/Instagram) — se vier menos que isso, não há mais itens.
  private readonly dialogPageSize = 10;

  // Página do Facebook — seleção explícita + leitura de conteúdo sob demanda (uso: pages_read_engagement)
  facebookPages: FacebookPage[] = [];
  loadingFacebookPages = false;
  selectedPageId: string | null = null;
  pageFeedItems: any[] = [];
  pageFeedInfo: { id: string; name: string | null; picture: string | null; followers_count: number | null } | null = null;
  loadingPageFeed = false;
  pageFeedDialogVisible = false;
  private hasLoadedPageFeed = false;
  pageFeedAfter?: string;
  hasMorePageFeed = false;
  loadingMorePageFeed = false;

  // Posts do Instagram — leitura sob demanda (uso: instagram_basic)
  igPostsItems: any[] = [];
  loadingIgPosts = false;
  igPostsDialogVisible = false;
  private hasLoadedIgPosts = false;
  igPostsAfter?: string;
  hasMoreIgPosts = false;
  loadingMoreIgPosts = false;

  loadFacebookPages(fbId: string): void {
    this.facebookPages = [];
    this.loadingFacebookPages = true;

    this.gallery.listFacebookPages(50, undefined, fbId).subscribe({
      next: (res) => {
        this.facebookPages = res.data ?? [];
        this.loadingFacebookPages = false;
      },
      error: (error) => {
        this.loadingFacebookPages = false;
        this.errorHandler.handle(error, 'Falha ao buscar Páginas do Facebook.');
      }
    });
  }

  onSelectFacebookPage(pageId: string): void {
    this.selectedPageId = pageId;
    this.selectedPage = this.facebookPages.find(p => p.id === pageId);
    this.instagramAccount = undefined;
    this.pageFeedItems = [];
    this.pageFeedInfo = null;
    this.hasLoadedPageFeed = false;
    this.pageFeedAfter = undefined;
    this.hasMorePageFeed = false;
    this.igPostsItems = [];
    this.hasLoadedIgPosts = false;
    this.igPostsAfter = undefined;
    this.hasMoreIgPosts = false;
    this.resetAllInstagramTabs();

    this.loadInstagramAccountForPage(pageId);
  }

  abrirPostagensPagina(): void {
    this.pageFeedDialogVisible = true;
    if (!this.hasLoadedPageFeed) {
      this.loadPageFeed();
    }
  }

  private loadPageFeed(): void {
    if (!this.selectedFacebookAccountId || !this.selectedPageId) return;
    const fbId = this.selectedFacebookAccountId;
    const pageId = this.selectedPageId;

    this.loadingPageFeed = true;
    this.gallery.getFacebookPageFeed(pageId, fbId, this.dialogPageSize).subscribe({
      next: (res: any) => {
        this.pageFeedItems = res.data || [];
        this.pageFeedInfo = res.page || null;
        this.pageFeedAfter = res.paging?.cursors?.after;
        this.hasMorePageFeed = !!this.pageFeedAfter && this.pageFeedItems.length >= this.dialogPageSize;
        this.loadingPageFeed = false;
        this.hasLoadedPageFeed = true;
      },
      error: (error) => {
        this.loadingPageFeed = false;
        this.hasLoadedPageFeed = true;
        this.errorHandler.handle(error, 'Falha ao buscar postagens da Página.');
      }
    });
  }

  loadMorePageFeed(): void {
    if (!this.selectedFacebookAccountId || !this.selectedPageId || !this.pageFeedAfter) return;
    const fbId = this.selectedFacebookAccountId;
    const pageId = this.selectedPageId;

    this.loadingMorePageFeed = true;
    this.gallery.getFacebookPageFeed(pageId, fbId, this.dialogPageSize, this.pageFeedAfter).subscribe({
      next: (res: any) => {
        const newItems = res.data || [];
        this.pageFeedItems = [...this.pageFeedItems, ...newItems];
        this.pageFeedAfter = res.paging?.cursors?.after;
        this.hasMorePageFeed = !!this.pageFeedAfter && newItems.length >= this.dialogPageSize;
        this.loadingMorePageFeed = false;
      },
      error: (error) => {
        this.loadingMorePageFeed = false;
        this.errorHandler.handle(error, 'Falha ao carregar mais postagens.');
      }
    });
  }

  abrirPostagensInstagram(): void {
    this.igPostsDialogVisible = true;
    if (!this.hasLoadedIgPosts) {
      this.loadInstagramPosts();
    }
  }

  // A API do Instagram às vezes devolve um cursor "after" mesmo sem itens restantes de fato;
  // por isso exigimos que a página tenha vindo cheia (>= dialogPageSize) e, quando disponível,
  // que ainda faltem itens em relação ao media_count total da conta.
  private computeHasMoreIgPosts(cursor: string | undefined, newItemsCount: number): boolean {
    if (!cursor || newItemsCount < this.dialogPageSize) return false;
    const totalKnown = this.instagramAccount?.media_count;
    if (totalKnown !== undefined && totalKnown !== null) {
      return this.igPostsItems.length < totalKnown;
    }
    return true;
  }

  private loadInstagramPosts(): void {
    if (!this.instagramAccount?.id || !this.selectedFacebookAccountId) return;

    this.loadingIgPosts = true;
    this.gallery.listUserMedia(this.instagramAccount.id, this.selectedFacebookAccountId, this.dialogPageSize).subscribe({
      next: (res) => {
        this.igPostsItems = res.data || [];
        this.igPostsAfter = res.paging?.cursors?.after;
        this.hasMoreIgPosts = this.computeHasMoreIgPosts(this.igPostsAfter, this.igPostsItems.length);
        this.loadingIgPosts = false;
        this.hasLoadedIgPosts = true;
      },
      error: (error) => {
        this.loadingIgPosts = false;
        this.hasLoadedIgPosts = true;
        this.errorHandler.handle(error, 'Falha ao buscar posts do Instagram.');
      }
    });
  }

  loadMoreIgPosts(): void {
    if (!this.instagramAccount?.id || !this.selectedFacebookAccountId || !this.igPostsAfter) return;

    this.loadingMoreIgPosts = true;
    this.gallery.listUserMedia(this.instagramAccount.id, this.selectedFacebookAccountId, this.dialogPageSize, this.igPostsAfter).subscribe({
      next: (res) => {
        const newItems = res.data || [];
        this.igPostsItems = [...this.igPostsItems, ...newItems];
        this.igPostsAfter = res.paging?.cursors?.after;
        this.hasMoreIgPosts = this.computeHasMoreIgPosts(this.igPostsAfter, newItems.length);
        this.loadingMoreIgPosts = false;
      },
      error: (error) => {
        this.loadingMoreIgPosts = false;
        this.errorHandler.handle(error, 'Falha ao carregar mais posts.');
      }
    });
  }

  private loadInstagramAccountForPage(pageId: string): void {
    if (!this.selectedFacebookAccountId) return;
    const fbId = this.selectedFacebookAccountId;

    this.gallery.getInstagramAccountForPage(pageId, fbId).subscribe({
      next: (acc) => {
        if (!acc || !acc.id) {
          this.instagramAccount = null;
          return;
        }

        this.instagramAccount = { ...acc, page_id: pageId } as any;
        this.selectedInstagramAccountId = acc.id;
        this.selectedInstagramAccountIdChange.emit(acc.id);

        const payload = {
          instagram_user_id: acc.id,
          facebook_user_id: fbId,
          page_id: pageId
        };
        this.gallery.saveInstagramAccount(payload).subscribe({
          next: () => { },
          error: (error) => {
            this.errorHandler.handle(error, 'Autorização negada');
          }
        });
      },
      error: () => {
        this.instagramAccount = null;
      }
    });
  }

  @Output() showConectAccountChange = new EventEmitter<boolean>();
  showConectAccount = false;

  selectedInstagramAccountId?: string;

  userMedia: InstagramGalleryItem[] = [];
  userMediaAfter?: string;
  pageSizeUserMedia = 10;
  hasMoreUserMedia = false;
  allUserMediaCache: InstagramGalleryItem[] = [];

  mediaTypeOptions = [
    { label: 'Imagem', value: 'IMAGE' },
    { label: 'Reel', value: 'VIDEO' },
    { label: 'Carrossel', value: 'CAROUSEL_ALBUM' }
  ];

  selectedMediaTypes: string[] = [];
  selectedStoriesMediaTypes: string[] = [];
  userStories: InstagramGalleryItem[] = [];
  userStoriesAfter?: string;
  pageSizeUserStories = 10;
  hasMoreUserStories = false;
  allUserStoriesCache: InstagramGalleryItem[] = [];

  totalTaggedRecords = 0;
  maxCaptionLength = 10;
  captionDialogVisible = false;
  captionDialogText = '';
  selectedPost: any = null;
  postDialogVisible: boolean = false;
  instagramAccountsOptions: any[] = [];

  getMainText(): string {
    if (this.showConectAccount && !this.displayAguarde) {
      return 'Conecte uma conta do Instagram para começar';
    }
    if (!this.showConectAccount && !this.displayAguarde) {
      if (!this.selectedFacebookAccountId) {
        return 'Selecione uma conta';
      }
      if (!this.selectedPageId) {
        return 'Selecione a Página';
      }
      return 'Pronto para buscar mídias';
    }
    // Adicione outras condições se necessário...
    return '';
  }


  constructor(
    private gallery: InstagramGalleryService,
    private sanitizer: DomSanitizer,
    private errorHandler: ErrorHandlerService,
    private renderer: Renderer2,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {
    console.log('[Capacitor] referenced in InstagramGalleryComponent');
    }

  ngOnInit() {
    this.initInstagram();
  }



  adjustPanelPosition() { /* igual */ }
  adjustPanelPosition2() { /* igual */ }
  adjustPanelPosition3() { /* igual */ }
  adjustPanelPosition4() { /* igual */ }

  initInstagram() {
    this.displayAguarde = true;
    this.loadFacebookAccounts();
    this.tabs = [
      { label: 'HashTag', command: () => this.onTabChange('HashTag') },
      { label: 'Tags', command: () => this.onTabChange('Tags') },
      { label: 'Mídias', command: () => this.onTabChange('Mídias') },
      { label: 'Stories', command: () => this.onTabChange('Stories') }
    ];
    this.activeTab = this.tabs[0];

    // assim que inicializar, marca todas as opções
    const allValues = this.mediaTypeOptions.map(o => o.value);
    this.selectedHashtagMediaTypes = [...allValues];
    this.selectedTagsMediaTypes = [...allValues];
    this.selectedMediaTypes = [...allValues];
    this.selectedStoriesMediaTypes = [...allValues];
  }
  private loadFacebookAccounts() {
    this.gallery.getFacebookAccounts()
      .pipe(
        map(res => Array.isArray(res) ? res : res.accounts),
        catchError((error) => {
          //this.errorHandler.handle(error, 'Autorização negada');
          // Retorna array vazio para continuar o fluxo
          return of([]);
        }) // ⬅️ trata o 404 (ou qualquer erro) e devolve array vazio
      )
      .subscribe(fbAccts => {
        this.facebookAccounts = fbAccts.map(a => ({
          label: a.name, value: a.id, picture: a.picture
        }));

        this.displayAguarde = false;
        this.showConectAccount = this.facebookAccounts.length > 0 ? false : true;

        if (!this.showConectAccount) {
          this.facebookAccounts.push({
            id: null,
            label: 'Adicionar uma conta',
            value: 'add_account',
            picture: 'pi pi-plus'
          });
        }
      });
  }

  onHashtagChange(val: string) {
    this.hashtag = val;
    this.hashtagChange.emit(val);
  }
  onTabChange(label: string) {
    this.activeTab = this.tabs.find(t => t.label === label)!;
    this.activeTabChange.emit(this.activeTab);
  }
  onSearch() {
    if (!this.hashtag) { return; }
    this.loadMoreHashTag(true);
  }
  applyHashTagFilter() {
    this.media = this.rawMedia.filter(item => matchesMediaType(item, this.selectedHashtagMediaTypes));
    this.hashtagResults.emit(this.media);
  }

  /////////////////
  getVideoDurationFromUrl(url: string): Promise<number> {
    return new Promise((resolve, reject) => {
      if (!url) return resolve(0);
      const video = document.createElement('video');
      video.preload = 'metadata';
      video.src = url;
      video.onloadedmetadata = () => {
        // Duração em segundos
        resolve(video.duration || 0);
        // cleanup
        video.remove();
      };
      video.onerror = (e) => {
        resolve(0); // Não trava seu fluxo, retorna 0
        video.remove();
      };
    });
  }

  async enrichInstagramWithDuration(items: any[]): Promise<any[]> {
    const promises: Promise<void>[] = [];
    for (const item of items) {
      if (item.media_type === 'VIDEO' && item.media_url) {
        promises.push(
          this.getVideoDurationFromUrl(item.media_url).then(d => { item.duration = d; })
        );
      }
      if (item.media_type === 'CAROUSEL_ALBUM' && item.children?.data) {
        for (const child of item.children.data) {
          if (child.media_type === 'VIDEO' && child.media_url) {
            promises.push(
              this.getVideoDurationFromUrl(child.media_url).then(d => { child.duration = d; })
            );
          }
        }
      }
    }
    await Promise.all(promises);
    return items;
  }

  /////////////////

  LoadSearching: boolean = false;
  loadMoreHashTag(reset = false) {
    if (
      !this.hashtag ||
      !this.instagramAccount ||
      !this.selectedFacebookAccountId
    ) {
      return;
    }
    if (reset) {
      this.rawMedia = [];
      this.media = [];
      this.hashtagAfter = undefined;
      this.hasSearched = false;
    }

    const fbAccountId = this.selectedFacebookAccountId;
    this.LoadSearching = true;
    // **PASSA o instagramAccount.id como primeiro argumento**
    const call$ = this.mediaMode === 'recent'
      ? this.gallery.listHashtagMediaRecent(
        this.instagramAccount.id,
        this.hashtag,
        fbAccountId,
        this.pageSizeHashTag,
        this.hashtagAfter
      )
      : this.gallery.listHashtagMedia(
        this.instagramAccount.id,
        this.hashtag,
        fbAccountId,
        this.pageSizeHashTag,
        this.hashtagAfter
      );

    call$.subscribe({
      next: async (res) => {
        this.extractedByUrl = false;
        this.lastHashtagId = res.hastTag_id ?? undefined;

        const sanitized: InstagramGalleryItem[] = res.data.map(item => ({
          ...item,
          caption: item.caption
            ? item.caption.replace(/[\r\n]+/g, ' ').replace(/\s{2,}/g, ' ').trim()
            : ''
        }));

        await this.enrichInstagramWithDuration(sanitized);

        this.rawMedia = mergeUniqueItems(this.rawMedia, sanitized);
        this.hashtagAfter = res.paging?.cursors.after;
        this.hasMoreHashTag = !!this.hashtagAfter;
        this.applyHashTagFilter();
        this.hasSearched = true;
        this.displayAguarde = false;
        this.LoadSearching = false;
      },
      error: error => {
        this.LoadSearching = false;
        this.displayAguarde = false;
        this.hasSearched = true;
        if (error.status === 429) {
          this.hashtagLimitMessage = 'É possível consultar um máximo de 30 hashtags únicas em nome de uma conta comercial ou de criador de conteúdo do Instagram dentro de um período de 7 dias consecutivos.';
          this.showHashtagLimitDialog = true;
        } else if (this.showContent) {
          this.errorHandler.handle(error, 'Autorização negada');
        }
        // Só apaga resultados anteriores se essa era uma busca nova (sem nada
        // acumulado ainda) — falha ao carregar mais páginas não deve descartar
        // o que já foi carregado com sucesso.
        if (this.rawMedia.length === 0) this.hashtagResults.emit([]);
      }
    });
  }


  LoadSearchingTags: boolean = false;
  loadMoreTags(reset = false) {
    if (!this.instagramAccount?.id || !this.selectedFacebookAccountId) return;

    if (reset) {
      this.allTaggedMediaCache = [];
      this.taggedMedia = [];
      this.taggedOffset = 0;
      this.hasSearched1 = false;
      this.hasMoreTags = false;
    }

    //this.displayAguarde = true;
    this.LoadSearchingTags = true;

    // Fonte de verdade pra paginação: a fatia filtrada do cache — nunca o
    // cache cru. allTaggedMediaCache guarda TUDO que a API já retornou, sem
    // filtro (senão ampliar o filtro depois não recupera itens descartados).
    const filteredCache = () =>
      this.allTaggedMediaCache.filter(item => matchesMediaType(item, this.selectedTagsMediaTypes));

    const appendPage = () => {
      const filtered = filteredCache();
      const batch = filtered.slice(this.taggedOffset, this.taggedOffset + this.pageSizeTags);
      this.taggedMedia = [...this.taggedMedia, ...batch];
      this.taggedOffset += batch.length;
      this.hasMoreTags = this.taggedOffset < filtered.length;

      this.displayAguarde = false;
      this.LoadSearchingTags = false;
    };

    if (this.allTaggedMediaCache.length === 0) {
      // primeira vez: carrega tudo (API de Tags não pagina no servidor) e depois fatia
      this.gallery.listTaggedMedia(
        this.instagramAccount.id,
        this.selectedFacebookAccountId
      ).subscribe({
        next: async all => {
          // ─────────── limpeza de caption ───────────
          const sanitized: InstagramGalleryItem[] = all.map(item => ({
            ...item,
            caption: item.caption
              ? item.caption.replace(/[\r\n]+/g, ' ').replace(/\s{2,}/g, ' ').trim()
              : ''
          }));

          // >>>>>>> ENRIQUECE COM DURAÇÃO DOS VÍDEOS <<<<<<<
          await this.enrichInstagramWithDuration(sanitized);
          this.allTaggedMediaCache = sanitized;

          this.totalTaggedRecords = this.allTaggedMediaCache.length;
          appendPage();
          this.hasSearched1 = true;
          this.extractedByUrl = false;
          this.tagsResults.emit(filteredCache());
        },
        error: error => {
          this.hasSearched1 = true;
          this.displayAguarde = false;
          this.LoadSearchingTags = false;
          if (this.showContent) this.errorHandler.handle(error, 'Autorização negada');
          if (this.allTaggedMediaCache.length === 0) this.tagsResults.emit([]);
        }
      });
    } else {
      // já temos cache: só fatia a próxima página, sem novo fetch nem novo emit
      appendPage();
    }
  }
  applyTagsFilter() {
    // Disparado pelo multiselect de filtro (onChange no template). Mantém o
    // comportamento existente de revelar de uma vez tudo que casa com o novo
    // filtro, mas agora sincroniza taggedOffset/hasMoreTags com essa revelação
    // total — sem isso, trocar o filtro no meio da paginação e clicar
    // "Carregar mais" fatiava com um offset desatualizado.
    const filtered = this.allTaggedMediaCache.filter(item => matchesMediaType(item, this.selectedTagsMediaTypes));
    this.taggedMedia = filtered;
    this.taggedOffset = filtered.length;
    this.hasMoreTags = false;
    this.tagsResults.emit(filtered);
  }

  /**
   * Invalida o estado acumulado das 4 abas (caches, cursores, hasMore,
   * hasSearched, lastHashtagId, extractedByUrl) sem tocar nas preferências de
   * filtro do usuário (selectedXxxMediaTypes) — chamado sempre que a conta ou
   * a Página do Facebook selecionada muda, pra não deixar dado da conta
   * anterior visível/disponível nos eventos emitidos.
   */
  private resetAllInstagramTabs(): void {
    this.rawMedia = [];
    this.media = [];
    this.hashtagAfter = undefined;
    this.hasMoreHashTag = false;
    this.hasSearched = false;
    this.lastHashtagId = undefined;

    this.allTaggedMediaCache = [];
    this.taggedMedia = [];
    this.taggedOffset = 0;
    this.hasMoreTags = false;
    this.hasSearched1 = false;

    this.allUserMediaCache = [];
    this.userMedia = [];
    this.userMediaAfter = undefined;
    this.hasMoreUserMedia = false;
    this.hasSearched2 = false;

    this.allUserStoriesCache = [];
    this.userStories = [];
    this.userStoriesAfter = undefined;
    this.hasMoreUserStories = false;
    this.hasSearched3 = false;

    this.extractedByUrl = false;
  }

  onSelectAccount(fbId: string) {
    if (fbId === 'add_account') {
      this.conectInstagram();
      return;
    }

    this.selectedAccountId = fbId;
    this.selectedFacebookAccountId = fbId;
    this.selectedInstagramAccountId = undefined;
    this.instagramAccount = undefined;
    this.selectedPageId = null;
    this.selectedPage = undefined;
    this.pageFeedItems = [];
    this.pageFeedInfo = null;
    this.resetAllInstagramTabs();

    this.selectedFacebookAccountIdChange.emit(fbId);

    this.loadFacebookPages(fbId);
  }
  LoadSearchingMedia: boolean = false;
  loadMoreUserMedia(reset = false) {
    if (!this.instagramAccount) return;
    const fbAccountId = this.selectedFacebookAccountId!;
    // reset total
    if (reset) {
      this.allUserMediaCache = [];
      this.userMedia = [];
      this.userMediaAfter = undefined;
      this.hasMoreUserMedia = false;
      this.hasSearched2 = false;
    }

    this.LoadSearchingMedia = true;
    this.gallery
      .listUserMedia(this.instagramAccount.id, fbAccountId, this.pageSizeUserMedia, this.userMediaAfter)
      .subscribe({
        next: async res => {
          // ─────────── limpeza de caption ───────────
          const acct = this.instagramAccount;
          const sanitized: InstagramGalleryItem[] = res.data.map(item => ({
            ...item,
            caption: item.caption
              ? item.caption.replace(/[\r\n]+/g, ' ').replace(/\s{2,}/g, ' ').trim()
              : '',
            is_own_media: true,
            insights: {
              like_count: item.like_count || 0,
              comment_count: item.comments_count || 0,
              insights: {
                username: acct?.username || acct?.label || '',
                name: acct?.name || acct?.username || acct?.label || '',
                profile_picture: acct?.picture || '',
              }
            }
          }));

          // >>>>>>> ENRIQUECE COM DURAÇÃO DOS VÍDEOS <<<<<<<
          await this.enrichInstagramWithDuration(sanitized);

          this.allUserMediaCache = mergeUniqueItems(this.allUserMediaCache, sanitized);
          this.userMediaAfter = res.paging?.cursors.after;
          this.hasMoreUserMedia = !!this.userMediaAfter;
          this.applyUserMediaFilter();
          this.displayAguarde = false;
          this.LoadSearchingMedia = false;
          this.hasSearched2 = true;
          this.extractedByUrl = false;
        },
        error: error => {
          this.hasSearched2 = true;
          this.displayAguarde = false;
          this.LoadSearchingMedia = false;
          if (this.showContent) this.errorHandler.handle(error, 'Autorização negada');
          // Só apaga resultados anteriores se não havia nada acumulado ainda —
          // falha ao carregar mais páginas não deve descartar o que já carregou.
          if (this.allUserMediaCache.length === 0) this.mediaResults.emit([]);
        }
      });
  }
  applyUserMediaFilter() {
    this.userMedia = this.allUserMediaCache.filter(item => matchesMediaType(item, this.selectedMediaTypes));
    this.mediaResults.emit(this.userMedia);
  }

  LoadSearchingStories: boolean = false;
  loadMoreUserStories(reset = false) {
    if (!this.instagramAccount) return;
    const fbAccountId = this.selectedFacebookAccountId!;

    if (reset) {
      this.allUserStoriesCache = [];
      this.userStories = [];
      this.userStoriesAfter = undefined;
      this.hasMoreUserStories = false;
      this.hasSearched3 = false;
    }

    this.LoadSearchingStories = true;
    this.gallery
      .listUserStories(this.instagramAccount.id, fbAccountId, this.pageSizeUserStories, this.userStoriesAfter)
      .subscribe({
        next: async res => {
          // ─────────── limpeza de caption ───────────
          const acct = this.instagramAccount;
          const sanitized: InstagramGalleryItem[] = res.data.map(item => ({
            ...item,
            caption: item.caption
              ? item.caption.replace(/[\r\n]+/g, ' ').replace(/\s{2,}/g, ' ').trim()
              : '',
            is_own_media: true,
            insights: {
              like_count: item.like_count || 0,
              comment_count: item.comments_count || 0,
              insights: {
                username: acct?.username || acct?.label || '',
                name: acct?.name || acct?.username || acct?.label || '',
                profile_picture: acct?.picture || '',
              }
            }
          }));

          // >>>>>>> ENRIQUECE COM DURAÇÃO DOS VÍDEOS <<<<<<<
          await this.enrichInstagramWithDuration(sanitized);

          this.allUserStoriesCache = mergeUniqueItems(this.allUserStoriesCache, sanitized);
          this.userStoriesAfter = res.paging?.cursors.after;
          this.hasMoreUserStories = !!this.userStoriesAfter;
          this.applyUserStoriesFilter();
          this.displayAguarde = false;
          this.LoadSearchingStories = false;
          this.hasSearched3 = true;
          this.extractedByUrl = false;
        },
        error: error => {
          this.hasSearched3 = true;
          this.displayAguarde = false;
          this.LoadSearchingStories = false;
          if (this.showContent) this.errorHandler.handle(error, 'Autorização negada');
          if (this.allUserStoriesCache.length === 0) this.storiesResults.emit([]);
        }
      });
  }
  applyUserStoriesFilter() {
    this.userStories = this.allUserStoriesCache.filter(item => matchesMediaType(item, this.selectedStoriesMediaTypes));
    this.storiesResults.emit(this.userStories);
  }

  openCaptionDialog(text: string) {
    this.captionDialogText = text;
    this.captionDialogVisible = true;
  }
  closeCaptionDialog() {
    this.captionDialogVisible = false;
  }

  @Output() openPostDialog = new EventEmitter<any>();
  openDialog(item: any) {
    this.openPostDialog.emit(item);
  }


  closePostDialog() {
    this.postDialogVisible = false;
    this.selectedPost = null;
  }
  conectInstagram() {
    this.confirmationService.confirm({
      message: `Deseja continuar?`,
      header: 'Você será redirecionado para outra página.',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.instagramConnection();
      },
      reject: () => {
        // não faz nada se cancelar
      }
    });
  }

  private storageBridge?: BroadcastChannel;
  instagramConnection(): void {
    this.setupStorageBridgeForPopup();
    this.startOAuthPopupListener(); // ✅ inicia o listener

    const clientId = '4107655592889616';
    const redirectUri = encodeURIComponent('https://app.slicksell.com.br/auth/instagram');
    const scopes = [
      'instagram_basic',
      'pages_show_list',
      'pages_manage_metadata',
      'instagram_manage_comments',
      'pages_read_engagement',
      'business_management',
      'instagram_manage_insights',
    ].join(',');
    const isNative = Capacitor.isNativePlatform();
    const selectedStoreId = localStorage.getItem('ss_SelectedStoreId') || '';
    let stateObj: any = { selectedStoreId };
    if (isNative) {
      const accessToken = localStorage.getItem('access_token') || '';
      stateObj.accessToken = accessToken;
    }
    stateObj.nonce = Math.random().toString(36).substring(2);
    const state = btoa(JSON.stringify(stateObj));

    localStorage.setItem('instagram_oauth_state', state);

    const oauthUrl = [
      'https://www.facebook.com/v22.0/dialog/oauth?',
      `client_id=${clientId}`,
      `&redirect_uri=${redirectUri}`,
      `&scope=${encodeURIComponent(scopes)}`,
      `&response_type=code`,
      `&state=${state}`,
    ].join('');

    window.open(oauthUrl, 'Instagram Login', 'width=600,height=700');
  }
  @Input() selectedItems: any[] = [];
  @Output() selectedItemsChange = new EventEmitter<any[]>();
  isItemSelected(item: any): boolean {
    return this.selectedItems.some(i => i.id === item.id);
  }
  public clearSelectedItems() {
    this.selectedItemsChange.emit([]);
    // Se precisar, limpe só os arrays locais (mas NÃO o selectedItems):
    this.media = [];
    this.taggedMedia = [];
    this.userMedia = [];
    this.userStories = [];
  }

  toggleSelection(item: any): void {
    const idx = this.selectedItems.findIndex(i => i.id === item.id);
    let newSelected: any[];
    if (idx >= 0) {
      // Remove item (imutável)
      newSelected = [
        ...this.selectedItems.slice(0, idx),
        ...this.selectedItems.slice(idx + 1)
      ];
    } else {
      // Adiciona item (imutável)
      newSelected = [...this.selectedItems, item];
    }
    this.selectedItemsChange.emit(newSelected);
  }

  isSelected(item: any): boolean {
    return this.selectedItems.some(i => i.id === item.id);
  }
  findSwiperById(id: string): Swiper | null {
    const swiperEl = document.querySelector(`[data-uid="${id}"]`) as HTMLElement & { swiper?: Swiper };

    if (!swiperEl || !swiperEl.swiper) {
      console.warn(`Swiper não encontrado para id: ${id}`);
      return null;
    }

    return swiperEl.swiper;
  }
  slideToPrev(id: string) {
    const swiper = this.findSwiperById(id);
    if (swiper) swiper.slidePrev();
  }
  slideToNext(id: string) {
    const swiper = this.findSwiperById(id);
    if (swiper) swiper.slideNext();
  }



  private setupStorageBridgeForPopup(): void {
    if (this.storageBridge) return;
    this.storageBridge = new BroadcastChannel('oauth-storage');

    this.storageBridge.onmessage = (e) => {
      if (e.data?.type === 'request-storage') {
        // Envie as chaves que a popup precisa
        this.storageBridge?.postMessage({
          type: 'storage-dump',
          payload: {
            SelectedStoreId: localStorage.getItem('ss_SelectedStoreId'),
            user_id: localStorage.getItem('user_id')
          }
        });
      }
    };
  }


  private oauthChannel: BroadcastChannel | null = null;

  private startOAuthPopupListener(): void {

    if (this.oauthChannel) return;
    this.oauthChannel = new BroadcastChannel('oauth-channel');

    this.oauthChannel.onmessage = (event) => {

      switch (event.data?.type) {
        case 'instagram-connected':

          // pequeno atraso pra backend consolidar e UI mostrar o toast
          setTimeout(() => {
            try { this.oauthChannel?.close(); } catch { }
            this.oauthChannel = null;
            window.focus();
            window.location.reload(); // ⬅️ atualiza a aba chamadora somente quando chegou a msg
          }, 0);

          break;

        case 'shopify-connected':

          // pequeno atraso pra backend consolidar e UI mostrar o toast
          setTimeout(() => {
            try { this.oauthChannel?.close(); } catch { }
            this.oauthChannel = null;
            window.focus();
            window.location.reload(); // ⬅️ atualiza a aba chamadora somente quando chegou a msg
          }, 0);

          break;

        default:
          console.warn('⚠️ Tipo de mensagem desconhecido:', event.data?.type);
          break;
      }
    };

  }


  ngOnDestroy(): void {
    if (this.oauthChannel) {
      this.oauthChannel.close();
      this.oauthChannel = null;
    }
  }



  collapsed: { igMain: boolean; igExtract: boolean } = {
    igMain: true,   // fechada
    igExtract: true  // fechada
  };

  toggle(section: 'igMain' | 'igExtract'): void {
    this.collapsed[section] = !this.collapsed[section];
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isFeed']) {
      this.updateCollapsed();
    }
    if (changes['showContent'] && !changes['showContent'].firstChange) {
      this.initInstagram();
    }
  }

  updateCollapsed() {
    this.collapsed.igMain = this.isFeed ? false : true;
    this.collapsed.igExtract = true;
  }

  igUrl = '';
  extractingIg = false;
  // Pode deixar como readonly no component
  private readonly IG_PROXY_BASE = 'https://cdn.slicksell.com.br/ig-proxy';

  // Ideal: receber do backend. Por agora, use o mesmo valor que você mostrou:
  private readonly IG_HASH_ID = 'v5b%2524Ie%2525aqOo%2524RgH%2524Z76lDzN3Zx6YATpoMibB18G%2540';

  private proxyIg(url?: string | null): string {
    if (!url) return '';
    // evita dupla proxificação
    if (url.startsWith(this.IG_PROXY_BASE)) return url;
    return `${this.IG_PROXY_BASE}?hash-id=${encodeURIComponent(this.IG_HASH_ID)}&url=${encodeURIComponent(url)}`;
  }

  // mapa “raw -> card/dataview” (mesma ideia do TikTok)
  private mapInstagramExtractItemsToRaw(items: any[]): any[] {
    return (items || []).map((raw: any) => {
      const d = raw.data ?? raw;

      const id = d.id || d.shortcode || raw.id || '';
      const code = d.shortcode || id;

      ////////////////
      // detecta Reel / IGTV para permalink correto quando não vier pronto do provedor
      const productType = (d.product_type || d.productType || '').toLowerCase();
      const looksLikeReel = /\/reel\//i.test(d.permalink || '') || productType === 'clips';
      const looksLikeIgtv = /\/tv\//i.test(d.permalink || '') || productType === 'igtv';

      const permalink =
        d.permalink
          ? d.permalink
          : (looksLikeReel
            ? `https://www.instagram.com/reel/${code}/`
            : looksLikeIgtv
              ? `https://www.instagram.com/tv/${code}/`
              : `https://www.instagram.com/p/${code}/`);

      // const permalink =
      //   d.permalink || (code ? `https://www.instagram.com/p/${code}/` : '');
      ////////////////

      const caption =
        d.caption || d.title || d.description || d.edge_media_to_caption?.edges?.[0]?.node?.text || '';

      // SE vier do backend padronizado:
      const hasChildren = Array.isArray(d.children?.data) && d.children.data.length > 0;

      const mediaTypeBackend = d.media_type || (d.is_video ? 'VIDEO' : 'IMAGE');
      const isCarousel = mediaTypeBackend === 'CAROUSEL_ALBUM' || hasChildren;

      const isVideo = !isCarousel && !!(d.is_video ?? d.isVideo ?? (d.media_type === 'VIDEO') ?? false);

      const displayUrl =
        d.display_url || d.thumbnail_url || d.image_versions2?.candidates?.[0]?.url || d.thumbnail_src || '';

      const videoUrl = d.video_url || d.video_versions?.[0]?.url || null;

      const tsIso = d.timestamp || (d.taken_at_timestamp ? new Date(d.taken_at_timestamp * 1000).toISOString() : undefined);

      const likeCount =
        d.like_count ?? d.edge_media_preview_like?.count ?? d.edge_liked_by?.count ?? Number(d.statistics?.likeCount ?? 0);
      const commentCount =
        d.comment_count ?? d.edge_media_to_parent_comment?.count ?? Number(d.statistics?.commentCount ?? 0);



      const owner = d.owner || d.user || d.author || {};
      const username = owner.username || '';
      const name = owner.full_name || username || '';
      const profilePicture = owner.profile_pic_url || owner.profile_pic_url_hd || owner.avatar || '';

      const proxiedImage = this.proxyIg(displayUrl);

      // ---- Children normalizados (quando houver) ----
      let mappedChildren: any[] = [];
      if (isCarousel) {
        // fonte preferencial: já padronizado pelo backend
        const childrenArr = (d.children?.data ?? [])
          // fallback: alguns providers devolvem em 'edge_sidecar_to_children.edges'
          .concat((d.edge_sidecar_to_children?.edges ?? []).map((e: any) => e?.node).filter(Boolean) || []);

        mappedChildren = (childrenArr || []).map((child: any) => {
          const cDisplay =
            child.display_url || child.thumbnail_url || child.image_versions2?.candidates?.[0]?.url || child.thumbnail_src || '';
          const cVideo = child.video_url || child.video_versions?.[0]?.url || null;

          const cIsVideo =
            (child.is_video ?? false) === true ||
            !!cVideo ||
            (child.media_type === 'VIDEO');

          const thumb = this.proxyIg(cDisplay);

          return {
            id: child.id || child.shortcode || '',
            media_type: cIsVideo ? 'VIDEO' : 'IMAGE',
            media_url: cIsVideo ? (cVideo || '') : thumb,
            thumbnail_url: thumb,
            video_url: cVideo,
            caption: (child.caption || '').trim?.() || '',
            timestamp: child.timestamp || tsIso
          };
        });
      }

      return {
        id,
        // 👇 adicione estes campos para o backend ter fallback
        shortcode: code,
        code, // redundante, mas seu backend já procura "code"
        // ...
        media_type: isCarousel ? 'CAROUSEL_ALBUM' : (isVideo ? 'VIDEO' : 'IMAGE'),
        // IMPORTANTE: para o pai de carrossel, mantenha imagem (proxy) como cover
        media_url: isCarousel ? proxiedImage : (isVideo ? (videoUrl || '') : proxiedImage),
        caption: caption || '(sem descrição)',
        timestamp: tsIso,
        permalink,

        username,
        name,
        profile_picture: profilePicture,
        like_count: Number(likeCount || 0),
        comment_count: Number(commentCount || 0),
        video_url: isCarousel ? null : videoUrl, // vídeos ficam nos filhos quando for carrossel
        thumbnail_url: proxiedImage,

        // shape IG Graph compatível com seus outros fluxos
        ...(isCarousel ? { children: { data: mappedChildren } } : {})
      };
    });
  }

  extractedByUrl: boolean = false;
  extractInstagram(reset = false) {
    if (!this.igUrl) return;

    if (reset) {
      this.rawMedia = [];
      this.media = [];
      this.hasSearched = false;
    }

    this.extractingIg = true;

    this.gallery.extractInstagramByUrlPublic(this.igUrl).subscribe({
      next: async (res: any) => {
        let raw = this.mapInstagramExtractItemsToRaw(res.items || []);
        // ENRIQUECE com duration se for vídeo!
        raw = await this.enrichInstagramWithDuration(raw);

        this.rawMedia = mergeUniqueItems(this.rawMedia, raw);
        // applyHashTagFilter() já recomputa `media` e emite via hashtagResults
        // (a extração por URL reaproveita o estado da aba HashTag).
        this.applyHashTagFilter();

        this.hasSearched = true;
        if (!this.media.length) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Nada encontrado',
            detail: 'Não foi possível extrair conteúdo dessa URL.'
          });
        }
        this.extractedByUrl = true;
        this.extractingIg = false;
      },
      error: (error) => {
        this.extractingIg = false;
        this.errorHandler.handle(error, 'Falha ao extrair o post do Instagram.');
        if (this.rawMedia.length === 0) this.hashtagResults.emit([]);
      }
    });
  }
  instagramRegex = /^(https?:\/\/)?(www\.)?instagram\.com\/(p|tv|reel)\/[\w\-]+\/?(\?.*)?$/i;
  igInvalid: boolean = false;

  checkIgUrl() {
    this.igInvalid = !!this.igUrl && !this.instagramRegex.test(this.igUrl.trim());
  }

}

